/* __next_internal_client_entry_do_not_use__ default auto */import { notLoginHandle } from "@/helpers/blog";
import { useEffect } from "react";
const EventInjector = () => {
  useEffect(() => {
    document.addEventListener("click", e => {
      var _current_parentElement, _current_parentElement1;
      let current = e.target;
      if (!current) return;
      if ((current === null || current === void 0 ? void 0 : current.id) === "TryIt" || (current === null || current === void 0 ? void 0 : (_current_parentElement = current.parentElement) === null || _current_parentElement === void 0 ? void 0 : _current_parentElement.id) === "TryIt") {
        notLoginHandle();
      }
      let classList = [...current.classList];
      let parentClassList = [...((current === null || current === void 0 ? void 0 : (_current_parentElement1 = current.parentElement) === null || _current_parentElement1 === void 0 ? void 0 : _current_parentElement1.classList) || [])];
      if (classList.includes("") || parentClassList.includes("register-dom")) {
        notLoginHandle();
      }
    });
  }, []);
  return null;
};
export default EventInjector;